import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeContent(_id:$_id){
        recordId
      }
}
`